import styled from 'styled-components';

export const StyledH2 = styled.h2`
  margin-bottom: 20px;
`;
